import { SystemField } from "./system-field";
import { Property } from "./property";

export class ProductProperty extends SystemField{
     
     properties_id?:string;
     products_id?:string;
     code?:string;
     is_active?:number;
     not_delete?: number;
     property?:Property;

     langs?:any = {en : new ProductPropertyTranslation()};
}
export class ProductPropertyTranslation extends SystemField{
     lang_code?:string;
     value?:string;
     product_properties_id?:string;
}